export default __webpack_public_path__ + "static/media/ibrahim.32fd0487.png";